/**
 * @copyright Copyright 2020 Epic Systems Corporation
 * @file API to get query string parameter from URL
 * @author Alex Brizius
 */

export function getQueryStringParameter(href: string, key: string): string {
	const expression = new RegExp(".*?.*" + key + "=([^&]+)", "i");
	const match = href.match(expression);
	if (match && match.length > 0) {
		return match[1];
	}
	return "";
}